define('presentation/common/callDetails/presentationObjects/callDetailsVoicemailPresentationObject',[],function() {
    return function(){
        const self = this;

        self.status = ko.observable("");
        self.voicemailMessageId = null;
        self.voicemailMessageStatus = null;
        self.voicemailIsDeleted = false;
        self.voicemailDeletedDateTime = null;
        self.voicemailAudioUrl = null;
        self.durationInSeconds = null;
        self.canListenToVoicemail = false;
        self.subscriberIds = ko.observableArray([]);
        self.isDeleted = ko.observable(false);
    };
});

